/* eslint-disable react/prop-types */
import React from 'react';
import classNames from 'classnames';
import { FormattedMessage } from 'react-intl';

import clickoutScript from '../../utils/clickoutScript';
import { getSubCategoryFullSlug, getTopBrandsText } from './sdpUtils';

import styles from './ShopDetailsPage.module.scss';

const SDPTopBrands = ({ shopInfo, config, intlFull, clickout }) => {
  const topBrands = shopInfo?.tops?.brands?.buckets;
  const assortment = shopInfo?.tops?.assortment?.buckets.map((category) => ({
    ...category,
    url: getSubCategoryFullSlug(category),
  }));

  return (
    topBrands?.length >= 2 && (
      <div className={classNames(styles.topBrands)}>
        <h2>
          <FormattedMessage
            id="shop.topBrandsHeader"
            defaultMessage="Brands at shop"
            values={{ shopName: shopInfo.shop_name }}
          />
        </h2>
        <p>
          <FormattedMessage
            defaultMessage="At this shop you will find an extensive range of branded products."
            id="shop.brandedProductsText"
            values={{
              shopName: shopInfo.shop_name,
              topBrandsText: getTopBrandsText(topBrands, shopInfo, config, intlFull),
              assortment: intlFull.formatList(
                assortment.slice(0, 3).map(({ key }) => key.toLowerCase()),
                { type: 'conjunction' }
              ),
              shopLink: (
                <a
                  onClick={() => clickoutScript(shopInfo.shop_link, clickout, false)}
                  href={clickoutScript(shopInfo.shop_link, clickout, true)}
                  rel="noopener noreferrer"
                  target="_blank"
                >
                  {shopInfo.shop_name}
                </a>
              ),
            }}
          />
        </p>
      </div>
    )
  );
};

export default SDPTopBrands;
